/**
 * 定数値を記述するファイル
 */
export const ConstCheckList = {
  MaxNotesLength: 1000
};

export const ConstWorkCheckList = {
  MaxNotesLength: 10000
};
